module.exports = __webpack_public_path__ + "static/img/David_Swallow_desktop.891b54f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David_Swallow_desktop.jpg
// module id = bnJn
// module chunks = 0